<template>
  <div class="orderdetail">
    <cube-page type="orderdetail-view" title="退单详情">
      <div slot="content">
        <div class="orderitem">
          <div class="ordertitle">
            <p>退单号：{{refund.refund_no}}</p>
            <p class="colorred">{{refund.status_text}}</p>
          </div>
          <div class="ordemain">
            <div class="ordecontent">
              <div class="order">
                <van-image radius="8" width="88" height="90" :src="refund.image"/>
                <div class="orderright">
                  <p class="ordername ells">{{refund.goods_name}}</p>
                  <div class="carddesc">
                    <span>使用时间：</span>
                    <span>{{refund.use_date}}</span>
                  </div>
                  <div class="carddesc">
                    <span>退款数量：</span>
                    <span>{{refund.refund_num}}</span>
                  </div>
<!--                  <div class="carddesc">
                    <span>退款金额：</span>
                    <span>{{refund.amount}}</span>
                  </div>-->
                  <div class="carddesc">
                    <span>申请时间：</span>
                    <span>{{refund.createtime}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <van-collapse v-model="activeNames">
          <van-collapse-item title="退单详情" name="1">
            <div class="itembox">
              <div class="itemright">
                <div class="itemxx" v-if="refund.handle_role_text">
                  审核角色：
                  <span>{{refund.handle_role_text}}</span>
                </div>
                <div class="itemxx" v-if="refund.handle_user">
                  审核人：
                  <span>{{refund.handle_user}}</span>
                </div>
                <div class="itemxx" v-if="refund.handletime">
                  审核时间：
                  <span>{{refund.handletime}}</span>
                </div>
                <div class="itemxx" v-if="refund.remarks">
                  退单备注：
                  <span>{{refund.remarks}}</span>
                </div>
                <div class="itemxx" v-if="refund.emo">
                  审核备注：
                  <span>{{refund.emo}}</span>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <div  v-for="(goods,index) in list" :key="index">
            <van-collapse-item :title="goods.goods_attr">
              <van-checkbox-group v-model="result" ref="checkboxGroup">
                <div class="itembox" v-for="(item,index) in goods.metas" :key="index">
                  <div class="itemright">
                    <div class="itemxx">
                      联系人：
                      <span>{{item.contacts}}</span>
                    </div>
                    <div class="itemxx">
                      联系电话：
                      <span class="phpne" @click="goPhone(item.telephone)">
                        {{item.telephone}}
                        <van-icon name="phone-o"/>
                      </span>
                    </div>
                    <div class="itemxx" v-if="item.IDCard">
                      证件号：
                      <span>{{item.IDCard}}</span>
                    </div>
                    <div class="itemxx" v-if="item.code">
                      核销码：
                      <span>{{item.code}}</span>
                    </div>
                    <div class="itemxx" v-if="item.code">
                      核销状态：
                      <span>{{item.use_status_text}}</span>
                    </div>
                    <div class="itemxx" v-if="item.use_num">
                      核销次数：
                      <span>{{item.use_num}}</span>
                    </div>
                    <div class="itemxx" v-if="item.last_use_time">
                      核销时间：
                      <span>{{item.last_use_time}}</span>
                    </div>
                  </div>
                </div>
              </van-checkbox-group>
            </van-collapse-item>
          </div>
        </van-collapse>
      </div>
    </cube-page>
  </div>
</template>

<script>
import CubePage from "../../TP/cube-page.vue";
import * as util from "@/utils/network";
import { Dialog,Toast, ImagePreview } from "vant";

export default {
  components: {
    CubePage
  },
  data() {
    return {
      store: null,
      activeNames: ["1", "2"],
      active: 0,
      txshow: false,
      xgprice: "",
      id: this.$route.query.id,
      isUpdate: this.$route.query.update,
      isShop: this.$route.query.isshop,
      isnoShow: this.$route.query.noShow ? "1" : null,
      list: {},
      refund: {},
      goods: {},
      detail: {
        address: {
          Area: {}
        }
      },
      disabled: false,
      gcfg: [],
      qrshow: false,
      resData: {},
      isPl: false,
      result: [],
      checkedall: false,
      tdshow: false,
      tdvalue: "",
      dateShow: false
    };
  },
  created() {
    this.gcfg = this.$store.getters.getGcfg;
    this.store = this.$store.getters.getShop;
    this.getData();
  },
  methods: {
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    //拨打电话
    goPhone(e) {
      window.location.href = "tel://" + e;
    },
    imgShow(url) {
      ImagePreview([url]);
    },

    getData() {
      let that = this;
      var url = "/addons/litestore/api.supplier/refundDetail";
      console.log(that.isUpdate);
      var parm = {
        id: that.id,
        metaIds: this.$route.query.metaIds,
        type: 2,
        goBack: "true"
      };
      if (that.isShop != undefined) {
        //util.isToken
        parm = {
          store_id: that.store.id,
          id: that.id
        };
      }
      //这里直接调用网络接口
      util.get(
        url,
        parm,
        function(result) {
          console.log(result);
          that.refund = result.data;
          that.list = result.data.goods;
        },
        function(err) {
          console.log(err);
        }
      );
    },
    decimalPoint(val) {
      const splitPrice = (val || "0.00").split(".");
      const numb1 = splitPrice[0];
      var numb2 = "00";
      if (splitPrice.length > 1) {
        numb2 = splitPrice[1];
      }
      return `${numb1}.<span style="font-size: 12px; line-height: 12px;">${numb2}</span>`;
    }
  },
  watch: {
    "$store.state.gcfg"() {
      this.gcfg = this.$store.getters.getGcfg;
    },
    "$store.state.shop"() {
      this.store = this.$store.getters.getShop;
    }
  }
};
</script>
<style lang="less" scoped="scoped">
@import url("../../../assets/css/order.css");
@import url("../../../assets/css/listboxless.less");

.ordemain {
  padding: 15px;

  .orderfooter {
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;

    .ordernum {
    }

    .orderjj {
      display: flex;
    }

    .item {
      padding-left: 15px;
      color: #aaabaf;

      .price {
        font-size: 15px;
        font-weight: 600;
      }
    }

    .blodspan {
      color: #000;
      font-weight: 600;
    }
  }
}

.ordecontent {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .order {
    flex: 1;
    width: 0;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .orderright {
      flex: 1;
      width: 0;
      flex-shrink: 0;
      padding: 0 10px;

      .ordername {
        font-size: 14px;
      }

      .orderdec {
        padding: 5px 0;
        font-size: 13px;
      }

      .carddesc {
        font-size: 12px;
      }

      .orderp {
        height: 28px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .ordernum {
          font-size: 12px;
          color: #969799;
        }

        .dj {
          span {
            font-size: 12px;
          }
        }
      }
    }
  }
}

.van-cell {
  background-color: #ffffff;
}

.van-collapse {
  padding-bottom: 80px;
}

.itembox {
  display: flex;
  align-items: center;
  padding: 5px 0;

  .itemleft {
    width: 60px;
  }

  .itemright {
    flex: 1;

    .itemxx {
      line-height: 25px;
    }
  }

  .itembtns {
    width: 78px;
  }
}

.itembox + .itembox {
  border-top: 1px solid #e5e5e5;
}
.td-flex {
  padding: 0 16px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  .itemxx {
    line-height: 25px;
    color: #969799;
    font-size: 14px;
    span {
      color: #000;
    }
  }
}
.fid-fo {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.footer-btns {
  box-shadow: 3px 5px 8px #787878;
  padding: 0 15px;
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
